<template>
  <div id="app" class="join-container">
    <div v-if="loading" class="overlay">
      <loading-icon></loading-icon>
    </div>
    <router-view v-else :merchant="merchant"/>
  </div>
</template>

<script>
  import AxiosMixin from '@/mixins/AxiosMixin'
  import LoadingIcon from '@/components/Shared/LoadingIcon'
  import router from '@/router/index'
  import config from './config'

  export default {
    components: {
      LoadingIcon,
      router
    },

    mixins: [AxiosMixin],

    data() {
      return {
        merchant: {},
        loading: false
      }
    },

    methods: {
      authSetup() {
        const id = this.urlParams('id')

        if(!id) { return router.push({path:'/no-access'}) }

        this.getMerchantData(id)
        this.setMerchantStyles(id)
      },

      getMerchantData(id) {
        this.loading = true
        this.axiosMethod({
          url: `/merchants/${id}`,
          onSuccess: this.setMerchantData,
          onError: (error) => {
            router.push({path:'/no-access'})
            this.loading = false
          }
        })
      },

      setMerchantStyles(id) {
        const styleUrl = `${config.baseApiUrl}/merchants/${id}/styles`,
            styleCss = `@import '${styleUrl}'`;
        let style = document.createElement("style");
        style.appendChild(document.createTextNode(styleCss));
        document.head.appendChild(style);
      },

      setMerchantData(response) {
        this.merchant = response.data?.merchant
        this.loading = false
      },

      urlParams(selectedParam) {
        const urlParams = location.search
        let params = {}
        if (urlParams) {
          urlParams.substr(1).split("&").forEach(function (item) {
            let key_value = item.split("=");
            if (key_value[0] && key_value[1]) {
              params[key_value[0]] = key_value[1].replace(/[\/]/gi, '')
            }
          })
          return params[selectedParam]
        }
      },
    },

    created() {
      this.authSetup()
    },
  }
</script>

<style lang="sass">
@import './assets/sass/reset'
@import './assets/sass/colors'
@font-face
  font-family: 'AileronThin'
  src: url('./assets/fonts/aileron/Aileron-Thin.eot')
  src: url('./assets/fonts/aileron/Aileron-Thin.eot?#iefix') format('embedded-opentype'), url('./assets/fonts/aileron/Aileron-Thin.woff') format('woff'), url('./assets/fonts/aileron/Aileron-Thin.ttf') format('truetype')
  font-weight: 100
  font-style: normal

@font-face
  font-family: 'AileronLight'
  src: url('./assets/fonts/aileron/aileron-light-webfont.woff2') format('woff2'), url('./assets/fonts/aileron/aileron-light-webfont.woff') format('woff'), url('./assets/fonts/aileron/aileron-light-webfont.ttf') format('truetype')
  font-weight: normal
  font-style: normal

/* Global Styles */
body, input, div
  font-family: "AileronThin", Helvetica, Roboto, Arial, sans-serif

#app
  font-family: "AileronThin", Helvetica, Roboto, Arial, sans-serif
  margin: auto
  max-width: 500px
  overflow: hidden
  padding: .5rem
  text-align: center

h3
  color: $title-color
  font-family: "AileronLight", Helvetica, Roboto, Arial, sans-serif
  font-size: 1.5rem
  margin: 1rem auto

p, label
  color: $title-color
  font-size: 1.25rem

input
  border-radius: 8px
  border: 1px solid $primary-color
  font-size: 1.25rem
  margin-bottom: 1.25rem
  padding: .5rem

.button
  background: $primary-color
  border-radius: 8px
  color: #ffffff
  cursor: pointer
  font-size: 1.25rem
  margin: auto
  padding: 0.5rem 2rem
  text-decoration: none
  transition: background 0.25s ease-out
  width: 50px

  &:hover
    background: $tertiary-color

.link
  color: $primary-color
  cursor: pointer
  transition: color 0.25s ease-out

  &:hover
    color: $tertiary-color

.page-notice
  background: $primary-transparent
  padding: 1rem
  border-radius: 8px
  margin: 1rem auto

.error-message
  color: $negative-hover
  font-size: .9rem

</style>
